module.exports = __webpack_public_path__ + "static/media/brand-amazon.316ca182.png";